var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenewLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81641 0.15332C8.43587 0.15332 9.78271 0.352702 10.8569 0.751465C11.9312 1.14209 12.7368 1.72803 13.2739 2.50928C13.8192 3.29053 14.0918 4.26302 14.0918 5.42676C14.0918 6.15104 13.9697 6.81022 13.7256 7.4043C13.4814 7.99837 13.1315 8.53141 12.6758 9.00342C12.2282 9.46729 11.6911 9.87419 11.0645 10.2241L16.2646 18H10.7959L7.01172 11.5059H5.79102V18H0.969238V0.15332H6.81641ZM6.74316 3.80322H5.79102V7.88037H6.69434C7.4349 7.88037 8.04118 7.71761 8.51318 7.39209C8.98519 7.06657 9.22119 6.4847 9.22119 5.64648C9.22119 5.06868 9.02588 4.61702 8.63525 4.2915C8.24463 3.96598 7.61393 3.80322 6.74316 3.80322Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewLogo);
export default __webpack_public_path__ + "static/media/renewLogo.b04443d94c4bc52ea1bd7ca64b7359ac.svg";
export { ForwardRef as ReactComponent };